import '@babel/polyfill';
import 'url-polyfill';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { enableLogging } from 'mobx-logger';

import App from './App';
import * as mobx from 'mobx';

mobx.configure({
  enforceActions: 'observed',
  useProxies: 'never'
});

if (process.env.NODE_ENV === 'development') {
  enableLogging({
    action: true,
    reaction: true,
    transaction: true,
    compute: true
  });
}

const root = createRoot(document.getElementById('container'));
root.render(<App />);
